<template>
  <vs-navbar class="topnavbar" back color text-color="red" active-text-color="red">
    <div slot="title" class="themelogo">
      <img :src="logo_url" v-if="logo" alt="Dashboard" height="45px" />
      <span class="logo-text" v-if="title">{{ title }}</span>
    </div>
    <!---
      Mobile toggle
      -->
    <div slot="title">
      <div class="cursor-pointer" @click.stop="activeSidebar">
        <vs-icon color="primary" icon="menu"></vs-icon>
      </div>
    </div>
    <vs-spacer></vs-spacer>
    <a class="mr-2">Hi, {{ this.$session.get("username") }}</a>
    <!-- <button class="btn-mode">
      <vs-icon :icon="icon_mode" class="mode" @click="onMode"></vs-icon>
    </button> -->
    <!-- <vs-icon icon="notifications_active" size="27px" color="success"></vs-icon> -->
    <v-google-translate :languages="lg" v-if="this.username == 'swiftdemo'" />
    <vs-dropdown vs-trigger-click>
      <span v-if="this.username != 'poonsak.ngk'">
        <vs-icon icon="notifications" size="27px" class="mode" v-if="alertlist.length == 0"></vs-icon>

        <span v-else class="fa-stack has-badge" :data-count="lastAlert.length">
          <vs-icon icon="notifications_active" size="27px" class="mode"></vs-icon>
        </span>
      </span>
      <vs-dropdown-menu class="loginx">
        <div class="p-3 mb-2">Notifications</div>
        <vs-list style="
              border-radius: 20px;
              height: auto;
              max-height: 400px;
              overflow-x: hidden;
            ">
          <span @click="viewAlert(item, aid[i])" v-for="(item, i) in lastAlert" :key="i">
            <vs-list-item v-if="item.alertstatus" class="bgHoverDis" :title="item.alertname"
              :subtitle="$moment(item.timestamp).fromNow()">
              <template slot="avatar">
                <vs-icon class="iconAvatarDis" icon="signal_cellular_alt"></vs-icon>
              </template>
              <!-- <a class="fontTime"> {{$moment(item.timestamp).fromNow()}}</a> -->
            </vs-list-item>
            <vs-list-item v-else class="bgHover" :title="item.alertname" :subtitle="$moment(item.timestamp).fromNow()">
              <template slot="avatar">
                <vs-icon class="iconAvatar" icon="signal_cellular_alt"></vs-icon>
              </template>
            </vs-list-item>
          </span>
        </vs-list>
      </vs-dropdown-menu>
    </vs-dropdown>
    <!---
      Craete new dd
      -->
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <span>
        <vs-icon icon="person" size="27px" class="mode"></vs-icon>
      </span>
      <vs-dropdown-menu class="topbar-dd">
        <!-- <vs-dropdown-item>
          <div class="topbar-dd-item">
            <span> Setting </span>
          </div>
        </vs-dropdown-item> -->
        <li @click="onMode" class="li-dropdown" v-if="ondark_mode">
          <a class="item-link">
            <div class="topbar-dd-item">
              <span>Dark mode</span>
              <vs-switch color="success" v-model="dark_mode" />
            </div>
          </a>
        </li>
        <vs-dropdown-item @click="tofeedback">
          <div class="topbar-dd-item">
            <span> Feedback Form </span>
          </div>
        </vs-dropdown-item>
        <!-- <vs-dropdown-item @click="onMode">
          <div class="topbar-dd-item">
            <span>Dark mode</span>
            <vs-switch color="success" v-model="dark_mode" />
          </div>
        </vs-dropdown-item> -->
        <vs-dropdown-item @click="logout">
          <div class="topbar-dd-item">
            <span> Log Out </span>
          </div>
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>

    <vs-dropdown vs-trigger-click class="cursor-pointer pr-2 pl-2 mr-1">
      <span>
        <icon-base viewBox="0 0 34 30" icon-name="Air-Condition" width="26" height="26"
          class="mode"><icon-nine-dot /></icon-base>
        <!-- :iconColor="icon_nav_color" -->
      </span>
      <vs-dropdown-menu class="topbar-dd-gosite">
        <vs-dropdown-item href="https://demo.sitearound.com/" target="_blank">
          <div class="img-item">
            <img src="@/assets/images/sentenance/sar_logo_1.png" alt="" />
          </div>
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </vs-navbar>
</template>

<script>
import useSound from "vue-use-sound";
import buttonSfx from "../../../assets/sound/YRL6BSM-siren.mp3";
import IconNineDot from "@/assets/icon/Icons/IconNineDot.vue";
import { io } from "socket.io-client";

export default {
  setup() {
    const [play] = useSound(buttonSfx);

    return {
      play,
    };
  },
  props: {
    topbarColor: {
      type: String,
      default: "#4F5467",
    },
    title: {
      type: String,
      default: "",
    },
    logo: {
      type: String,
      default: require("@/assets/images/logo/sentenance_logo.png"),
    },
    widthLogo: String,
    ondark_mode: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    IconNineDot,
  },
  data() {
    return {
      showToggle: false,
      search: "",
      guestKubota: "",
      network: "",
      alertlist: [],
      aid: [],
      username: "",
      admin: "",
      lastAlert: [],
      sensorId: [],
      oldLength: 0,
      firstLogin: true,
      icon_mode: "light_mode",
      dark_mode: false,
      logo_url: null,
      lg: [
        {
          code: "en",
          name: "English",
          cname: "英语",
          ename: "English",
        },
        {
          code: "th",
          name: "ไทย",
          cname: "泰语",
          ename: "Thai",
        },
      ],
      socket: undefined,
    };
  },
  computed: {
    alertlistCom: function () {
      return this.$store.getters["noti/alertlist"];
    },
    lastAlertCom: function () {
      return this.$store.getters["noti/lastAlert"];
    },
  },
  async mounted() {
    if (this.username == "yamahademo" || this.admin == "yamahademo") {
      console.log("connect wss");
      this.$store.dispatch("noti/connectWSSNoti", {
        path: "yamaha",
        callback: () => {
          // console.log('callback');
          this.$vs.notify({
            title: "Waring",
            text: "Your have alert is not disarm",
            color: "warning",
            position: "top-center",
            icon: "warning",
            fixed: true,
            click: () => {
              this.$router.push({ path: "/yamaha/alert" });
            },
          });
        },
      });
    }

    console.log();
    if (this.username == "betagrodemo" || this.admin == "betagrodemo") {
      this.$store.dispatch("setCookie", {
        name: "theme_mode",
        value: "dark_mode",
        days: 7,
      });
    }
    let mode = await this.$store.dispatch("getCookie", "theme_mode");
    let name_logo = this.logo.split("/")[2].split(".")[0];
    this.logo_url = this.logo;
    console.log("mode", mode);
    if (mode != null) {
      this.$store.commit("mode", mode);
      var r = document.querySelector(":root");

      if (this.$store.getters["mode"] == "dark_mode") {
        this.$store.dispatch("setCookie", {
          name: "theme_mode",
          value: "dark_mode",
          days: 7,
        });
        this.$store.commit("mode", "dark_mode");
        this.icon_mode = "dark_mode";
        this.dark_mode = true;
        r.style.setProperty("--background-color", "#000");
        r.style.setProperty("--background-color-sidebar", "#121212");
        r.style.setProperty("--background-color-navbar", "#121212");
        r.style.setProperty("--text-color", "#fff");
        r.style.setProperty("--icon-navbar", "#32C040");
        r.style.setProperty("--text-color-2", "#fff");
        r.style.setProperty("--background-login", "#000");
        // r.style.setProperty("--background-color", "#1E272E");
        // r.style.setProperty("--background-color-sidebar", "#2B343B");
        // r.style.setProperty("--background-color-navbar", "#2B343B");
        // r.style.setProperty("--text-color", "#fff");
        // r.style.setProperty("--icon-navbar", "#32C040");
        // r.style.setProperty("--background-login", "#1E272E");
        if (name_logo == "sentenance_logo") {
          this.logo_url = require("@/assets/images/logo/sentenance_logo_WH.png");
        }
      } else {
        this.$store.dispatch("setCookie", {
          name: "theme_mode",
          value: "light_mode",
          days: 7,
        });
        this.$store.commit("mode", "light_mode");
        this.icon_mode = "light_mode";
        this.dark_mode = false;
        r.style.setProperty("--background-color", "#fff");
        r.style.setProperty("--background-color-sidebar", "#fff");
        r.style.setProperty("--background-color-navbar", "#fff");
        r.style.setProperty("--text-color", "#000");
        r.style.setProperty("--icon-navbar", "#808080");
        r.style.setProperty("--background-login", "#f6f6f6");
        r.style.setProperty("--text-color-2", "#808080");

        if (name_logo == "sentenance_logo_WH") {
          this.logo_url = require("@/assets/images/logo/sentenance_logo.png");
        }
      }
    }
  },
  methods: {
    tofeedback() {
      this.$router.push({ path: "/CustomerSatisfactionForm" });
    },
    logx() {
      console.log("click");
    },
    onMode() {
      console.log(this.$store.getters["mode"]);
      console.log(this.logo_url);
      let name_logo = this.logo_url.split("/")[2].split(".")[0];
      console.log(name_logo);

      var r = document.querySelector(":root");
      if (this.$store.getters["mode"] == "dark_mode") {
        this.$store.dispatch("setCookie", {
          name: "theme_mode",
          value: "light_mode",
          days: 7,
        });
        this.$store.commit("mode", "light_mode");
        this.icon_mode = "light_mode";
        this.dark_mode = false;
        r.style.setProperty("--background-color", "#fff");
        r.style.setProperty("--background-color-sidebar", "#fff");
        r.style.setProperty("--background-color-navbar", "#fff");
        r.style.setProperty("--text-color", "#000");
        r.style.setProperty("--text-color-2", "#808080");
        r.style.setProperty("--icon-navbar", "#808080");
        if (name_logo == "sentenance_logo_WH") {
          this.logo_url = require("@/assets/images/logo/sentenance_logo.png");
        }
      } else {
        this.$store.dispatch("setCookie", {
          name: "theme_mode",
          value: "dark_mode",
          days: 7,
        });
        this.$store.commit("mode", "dark_mode");
        this.icon_mode = "dark_mode";
        this.dark_mode = true;
        // r.style.setProperty("--background-color", "#1E272E");
        // r.style.setProperty("--background-color-sidebar", "#2B343B");
        // r.style.setProperty("--background-color-navbar", "#2B343B");
        // r.style.setProperty("--text-color", "#fff");
        // r.style.setProperty("--icon-navbar", "#32C040");
        r.style.setProperty("--background-color", "#000");
        r.style.setProperty("--background-color-sidebar", "#121212");
        r.style.setProperty("--background-color-navbar", "#121212");
        r.style.setProperty("--text-color", "#fff");
        r.style.setProperty("--text-color-2", "#fff");
        r.style.setProperty("--icon-navbar", "#32C040");
        r.style.setProperty("--background-login", "#000");
        if (name_logo == "sentenance_logo") {
          this.logo_url = require("@/assets/images/logo/sentenance_logo_WH.png");
        }
      }
    },
    viewAlert(item, id) {
      console.log(item);
      this.dataIdSensor = id;
      this.dataAlert = item;
      // console.log(this.dataAlert);
      // console.log(this.dataIdSensor);
      this.$session.set("dataAlert", this.dataAlert);
      this.$session.set("dataIdSensor", this.dataIdSensor);
      // this.$router.push({
      //   name: "ViewAlert",
      //   params: { dataAlert: this.dataAlert, dataIdSensor: this.dataIdSensor }
      // });
      if (this.$route.name == "ViewAlert") {
        location.reload();
      } else {
        this.$router.push({
          name: "ViewAlert",
          params: {
            dataAlert: this.dataAlert,
            dataIdSensor: this.dataIdSensor,
          },
        });
      }
      // console.log(this.$route.name);
      // location.reload();
    },
    logout() {
      this.$session.clear();
      this.$router.push({ path: "/login" });
    },
    //This is for sidebar trigger in mobile
    activeSidebar() {
      if (this.$store.state.isSidebarActive) {
        this.$store.commit("IS_SIDEBAR_ACTIVE", false);
      } else {
        this.$store.commit("IS_SIDEBAR_ACTIVE", true);
      }
    },
    async getAlertData() {
      console.log("GET Alert");
      var tempAlert = [];
      var tempLast = [];
      this.role = this.$session.get("role");
      var tempel = {};
      var JSONcon = {};
      this.lastAlert = [];
      this.alertlist = [];

      await Promise.all([
        this.$API.get("sensors/indoor/user"),
        this.$API.get("alertlog/user")
      ]).then(([sensorlist_result, alert_result]) => {
        this.sensorlist = sensorlist_result.data;
        alert_result.data.forEach((element) => {
          JSONcon = JSON.parse(element.con);
          let sensor = this.sensorlist;
          if (sensor.length == 0) console.log("no sensor found");
          let count = 0;
          // console.log("element", element);
          if (Array.isArray(element.alerthistory)) {
              element.alerthistory.forEach((el) => {
                count += 1;
                // console.log(el);
                this.aid.push(element.id);
                this.sensorId.push(sensor[0].id);
                el.alertid = count;
                tempel = el;
                tempel.alertname = element.alertname;
                tempel.alertstatus = el.alertstatus;
                tempel.sensorname = JSONcon.loracon;
                tempel.sensorid = sensor[0].id;
                this.alertlist.push(el);
                tempel = {};
              });

              if (
                element.alerthistory[element.alerthistory.length - 1] &&
                element.alerthistory[element.alerthistory.length - 1].alertstatus
              ) {
                this.lastAlert.push(element.alerthistory[element.alerthistory.length - 1]);
              }
          } else {
            count += 1;
            this.aid.push(element.id);
            this.sensorId.push(sensor[0].id);
            tempel = {};
            tempel.alertid = count;
            tempel.alertname = element.alertname;
            tempel.alertstatus = element.alerthistory && element.alerthistory.alertstatus ? true : false;
            tempel.sensorname = element.sensorname;
            tempel.sensorid = sensor[0].id;
            if (tempel.alertstatus == true) {
              this.alertlist.push(element.alerthistory);
              tempel = {};
              this.lastAlert.push(element.alerthistory);
            }
          }
          const sortByDate = (arr) => {
            console.log("Doing");
            const sorter = (a, b) => {
              //***********Sort Descending******************
              return (
                new Date(b.timestamp).getTime() -
                new Date(a.timestamp).getTime()
              );
            };
            arr.sort(sorter);
          };
          sortByDate(this.lastAlert);
        })
                  //Insert Id
        let countId = 1;
        this.alertlist.forEach((element) => {
          element.alertid = countId;
          countId += 1;
        });

        //Set PrimeTable
        this.primeTable = this.alertlist;
        // console.log("this.lastAlert", this.lastAlert);
      })
      // await this.$API.get("sensors/indoor/user").then((result) => {
      //   // console.log(this.sensorlist)
      //   this.sensorlist = result.data;
      // });

      // this.lastAlert = [];
      // this.alertlist = [];
      // try {
      //   await this.$API.get("alertlog/user").then((result) => {
      //     result.data.forEach((element) => {
      //       // console.log(element);
      //       JSONcon = JSON.parse(element.con);
      //       // console.log(JSONcon)
      //       let sensor = this.sensorlist;
      //       if (sensor.length == 0) console.log("no sensor found");
      //       let count = 0;
      //       if (Array.isArray(element.alerthistory)) {
      //         element.alerthistory.forEach((el) => {
      //           count += 1;
      //           // console.log(el);
      //           this.aid.push(element.id);
      //           this.sensorId.push(sensor[0].id);
      //           el.alertid = count;
      //           tempel = el;
      //           tempel.alertname = element.alertname;
      //           tempel.alertstatus = el.alertstatus;
      //           tempel.sensorname = JSONcon.loracon;
      //           tempel.sensorid = sensor[0].id;
      //           this.alertlist.push(el);
      //           tempel = {};
      //         });

      //         if (
      //           element.alerthistory[element.alerthistory.length - 1] &&
      //           element.alerthistory[element.alerthistory.length - 1].alertstatus
      //         ) {
      //           this.lastAlert.push(element.alerthistory[element.alerthistory.length - 1]);
      //         }
      //       } else {
      //         count += 1;
      //         this.aid.push(element.id);
      //         this.sensorId.push(sensor[0].id);
      //         element.alerthistory.alertid = count;
      //         tempel = element.alerthistory;
      //         tempel.alertname = element.alertname;
      //         tempel.alertstatus = element.alerthistory && element.alerthistory.alertstatus ? true : false;
      //         tempel.sensorname = element.sensorname;
      //         tempel.sensorid = sensor[0].id;
      //         if (tempel.alertstatus == true) {
      //           this.alertlist.push(element.alerthistory);
      //           tempel = {};
      //           this.lastAlert.push(element.alerthistory);
      //         }
      //       }
            
      //       //Sort Alert By Date
      //       const sortByDate = (arr) => {
      //         const sorter = (a, b) => {
      //           //***********Sort Descending******************
      //           return (
      //             new Date(b.timestamp).getTime() -
      //             new Date(a.timestamp).getTime()
      //           );
      //         };
      //         arr.sort(sorter);
      //       };
      //       sortByDate(this.alertlist);
      //     });
      //     console.log("this.lastAlert", this.lastAlert)

      //     if (
      //       this.oldLength < this.lastAlert.length &&
      //       (this.username == "encodemo" || this.admin == "encodemo") &&
      //       !this.firstLogin
      //     ) {
      //       this.play();
      //     }
      //     this.firstLogin = false;
      //     this.oldLength = this.lastAlert.length;
      //     console.log("this.lastAlert", this.lastAlert);


      //     //Insert Id
      //     let countId = 1;
      //     this.alertlist.forEach((element) => {
      //       element.alertid = countId;
      //       countId += 1;
      //     });
      //     // console.log(this.alertlist);

      //     //Set PrimeTable
      //     this.primeTable = this.alertlist;
      //   });
      // } catch (error) {
      //   console.log(error);
      // }
      this.interval = setTimeout(() => {
        this.getAlertData();
      }, 30000);
    },
  },
  async created() {
    this.username = this.$session.get("username");
    this.admin = this.$session.get("admin");
    this.guestKubota = this.$session.get("guestKubotauser");
    if (this.admin != "yamahademo") {
      this.getAlertData();
    }
  },
  beforeDestroy() {
    clearTimeout(this.interval);
    this.$store.dispatch("noti/disconnectWSSNoti");
    console.log("beforeDestroy navbar");
  },
};
</script>

<style lang="scss" scoped>
.fa-stack[data-count]:after {
  position: absolute;
  right: -15%;
  top: -15%;
  content: attr(data-count);
  font-size: 60%;
  padding: 0.8em;
  border-radius: 999px;
  line-height: 0.9em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 3em;
  font-weight: bold;
}

.vs-list--subtitle {
  font-size: 0.2rem;
}

.bgHover:hover {
  background: rgba(var(--vs-primary), 0.08);
  cursor: pointer;
}

.iconAvatar {
  padding: 8px;
  background: rgba(var(--vs-primary), 0.08);
  color: #32c040;
  font-size: 25px;
  border-radius: 50%;
  margin-right: 15px;
}

.bgHoverDis:hover {
  background: rgba(var(--vs-warning), 0.08);
  cursor: pointer;
}

.iconAvatarDis {
  padding: 8px;
  background: rgba(var(--vs-warning), 0.08);
  color: #ff911e;
  font-size: 25px;
  border-radius: 50%;
  margin-right: 15px;
}

.bg-success {
  background-color: #32c040 !important;
}

.con-vs-dropdown--menu {
  width: 300px;
}

.btn-mode {
  background-color: transparent;
  border: none;
}

.mode {
  cursor: pointer;
  margin: 0 5px;
  color: var(--icon-navbar);
}

.topbar-dd {
  .topbar-dd-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;
  }
}

.topbar-dd-gosite {
  .img-item {
    display: flex;
    justify-content: center;

    img {
      // width: 70%;
      height: 30px;
      // margin-left: 50px;
    }
  }
}

.li-dropdown {
  transition: all 0.2s ease;
  position: relative;
  z-index: 100;
  border-radius: 5px;
  width: calc(100% - 6px);
  margin: 0 3px;
  list-style: none;
  font-weight: 400 !important;
  font-size: 0.9375em;

  .item-link {
    padding: 10px;
    background: inherit !important;
    color: inherit !important;
    cursor: pointer;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    padding: 5px;
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;
    position: relative;
    display: block;

    &:hover {
      color: rgba(var(--vs-primary), 1) !important;
      background: rgba(var(--vs-primary), 0.01) !important;
    }
  }
}
</style>
